var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "detail-body",
    },
    [
      _c("div", { staticClass: "spaceBetween" }, [
        _c("div", { staticClass: "detail-title-1" }, [_vm._v("Proposal Pool")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "spaceLeft search-form" },
          [
            _c("search-select", {
              attrs: {
                label: "Proposal results",
                options: _vm.typeOptions,
                "default-value": _vm.searchParams.status,
              },
              on: {
                valChange: function ($event) {
                  return _vm.valChange($event, "status")
                },
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sapceLeft search-item" },
              [
                _c("el-input", {
                  attrs: {
                    placeholder: "No...",
                    "suffix-icon": "el-icon-search",
                  },
                  on: { change: _vm.getList },
                  model: {
                    value: _vm.searchParams.id,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParams, "id", $$v)
                    },
                    expression: "searchParams.id",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.tableList, function (item, index) {
        return _c(
          "div",
          { key: index, staticClass: "pool-card" },
          [
            _c(
              "el-row",
              { staticClass: "pool-card_head" },
              [
                _c("el-col", { attrs: { xs: 24, sm: 24, md: 8, lg: 8 } }, [
                  _c(
                    "div",
                    { staticClass: "spaceLeft" },
                    [
                      _c(
                        "span",
                        {
                          staticStyle: {
                            color: "#6b6b6b",
                            "margin-right": "0.08rem",
                          },
                        },
                        [_vm._v("Proposal No : ")]
                      ),
                      _vm._v(" "),
                      _c("span", [_vm._v(" " + _vm._s(item.id))]),
                      _vm._v(" "),
                      _c("vote-status-comp", {
                        attrs: {
                          status: item.status,
                          over: item.over,
                          cumulative: item.vote,
                          threshold: _vm.threshold,
                        },
                        on: {
                          "update:status": function ($event) {
                            return _vm.$set(item, "status", $event)
                          },
                          "update:over": function ($event) {
                            return _vm.$set(item, "over", $event)
                          },
                          "update:cumulative": function ($event) {
                            return _vm.$set(item, "vote", $event)
                          },
                          "update:threshold": function ($event) {
                            _vm.threshold = $event
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "el-col",
                  { attrs: { xs: 24, sm: 24, md: 8, lg: 8 } },
                  [
                    item.myVote > 0
                      ? [
                          _c("span", { staticClass: "c1" }, [
                            _vm._v("My vote:"),
                          ]),
                          _vm._v(" "),
                          _c("big-number", {
                            staticClass: "c2",
                            attrs: { number: item.myVote },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "c1" }, [_vm._v("UNIT")]),
                        ]
                      : _c("span", [_vm._v("You haven't voted yet!")]),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    staticStyle: { "text-align": "right" },
                    attrs: { xs: 24, sm: 24, md: 8, lg: 8 },
                  },
                  [
                    _c("span", [_vm._v("End Block:")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(item.endBlock))]),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-row",
              { staticClass: "pool-card_body" },
              [
                _c("el-col", { attrs: { xs: 24, sm: 24, md: 10, lg: 10 } }, [
                  _c("div", { staticClass: "right-border" }, [
                    _c(
                      "div",
                      [
                        _c("voteFromTo", {
                          attrs: { title: item.title, desc: item.description },
                          on: {
                            "update:title": function ($event) {
                              return _vm.$set(item, "title", $event)
                            },
                            "update:desc": function ($event) {
                              return _vm.$set(item, "description", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticStyle: { "margin-top": "0.44rem" } }, [
                      _c("span", { staticClass: "c1" }, [_vm._v("Proposer :")]),
                      _vm._v(" "),
                      _c("span", { staticClass: "c2" }, [
                        _vm._v(_vm._s(item.proposer)),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "el-col",
                  {
                    staticClass: "right-border",
                    attrs: { xs: 24, sm: 24, md: 10, lg: 10 },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "progress_box",
                        staticStyle: { width: "85%", margin: "0 auto" },
                      },
                      [
                        _c("voteProgress", {
                          attrs: {
                            cumulative: item.totalWeight,
                            threshold: item.threshold,
                          },
                          on: {
                            "update:cumulative": function ($event) {
                              return _vm.$set(item, "totalWeight", $event)
                            },
                            "update:threshold": function ($event) {
                              return _vm.$set(item, "threshold", $event)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("el-col", { attrs: { xs: 24, sm: 24, md: 4, lg: 4 } }, [
                  _c("div", { staticClass: "pool-btn-box" }, [
                    _vm.showVote(item)
                      ? _c(
                          "div",
                          {
                            staticClass: "btn1",
                            on: {
                              click: function ($event) {
                                return _vm.handleVote(item)
                              },
                            },
                          },
                          [_vm._v("Vote")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "btn2",
                        on: {
                          click: function ($event) {
                            return _vm.voteDetail(item)
                          },
                        },
                      },
                      [
                        _c("svg-icon", { attrs: { "icon-class": "vote" } }),
                        _vm._v("\n            Vote Details\n          "),
                      ],
                      1
                    ),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.tableList.length == 0
        ? _c(
            "div",
            {
              staticStyle: {
                "text-align": "center",
                padding: "0.32rem",
                color: "#999",
                "font-size": "0.18rem",
                background: "#fafafa",
                "border-radius": "0.16rem",
                "margin-top": "0.16rem",
              },
            },
            [_vm._v("\n    No Data\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.queryParams.total > 0
        ? _c("pagination", {
            attrs: {
              total: _vm.queryParams.total,
              page: _vm.queryParams.page,
              limit: _vm.queryParams.pageSize,
            },
            on: {
              "update:total": function ($event) {
                return _vm.$set(_vm.queryParams, "total", $event)
              },
              "update:page": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.queryParams, "pageSize", $event)
              },
              pagination: function ($event) {
                return _vm.getList()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("voteDialog", { ref: "voteDialog", on: { success: _vm.refresh } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }